import { ReactNode } from "react";
import { InnerInitialValuesProvider } from "./inner-initial-values-provider";
import { InitialValues } from "./initial-values-types";
import { InitialValuesByTemplateId } from "./initial-values-by-template-id";

export function InitialValuesProvider({
  id,
  initialValues,
  children,
}: {
  id?: string;
  initialValues?: InitialValues;
  children: ReactNode;
}) {
  if (id) {
    return (
      <InitialValuesByTemplateId id={id}>{children}</InitialValuesByTemplateId>
    );
  }

  if (initialValues) {
    return (
      <InnerInitialValuesProvider initialValues={initialValues}>
        {children}
      </InnerInitialValuesProvider>
    );
  }

  return children;
}
